import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
	STRIPE_CARD_UPDATE_START, STRIPE_CARD_UPDATE_FAILED,
	updatePaymentOption
} from './actions';
import UpdatePaymentOptionDialog from './UpdatePaymentOptionDialog';

class PaymentOptionComponent extends Component {
	constructor(props) {
		super(props);

		this.showDialog = this.showDialog.bind(this);
		this.hideDialog = this.hideDialog.bind(this);
		this.handleDialogConfirm = this.handleDialogConfirm.bind(this);

		this.state = {
			showDialog: false
		}
	}

	showDialog() {
		this.setState({ showDialog: true });
	}

	hideDialog() {
		this.setState({ showDialog: false });
	}

	handleDialogConfirm(stripe, elements) {
		this.props.updatePaymentOption(stripe, elements, this.props.payment);
	}

	render() {
		const { payment, currency, paymentOptionUpdateError, t } = this.props;

		if (!payment || !payment.paymentOption) {
			return null;
		}

		return <React.Fragment>
			<span>{payment.paymentOption.toUpperCase()}<a style={{ cursor: 'pointer', marginLeft: 20 }} onClick={this.showDialog}>{t('FO_Payment_PaymentOption_Update')}</a></span>
			<UpdatePaymentOptionDialog
				payment={payment}
				currency={currency}
				show={this.state.showDialog}
				onConfirm={this.handleDialogConfirm}
				onCancel={this.hideDialog}
				block={STRIPE_CARD_UPDATE_START}
				unblock={STRIPE_CARD_UPDATE_FAILED}
				error={paymentOptionUpdateError}
			/>
		</React.Fragment>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const stripePaymentProcessor = state.paymentProcessors['Stripe'];
	const stripePayment = stripePaymentProcessor && stripePaymentProcessor.payments[ownProps.payment.id];

	return {
		paymentOptionUpdateError: stripePayment && stripePayment.paymentOptionUpdateError
	};
};

export default connect(mapStateToProps, {
	updatePaymentOption
})(withTranslation()(PaymentOptionComponent));